<template functional>
  <v-row>
    <v-col cols="12" sm="6" class="text-center">
      <slot
        name="left"
        :attributes="{
          exact: true,
          class: 'my-1',
          outlined: true,
          rounded: true,
          height: '40px',
          width: '100%',
          maxWidth: '332px'
        }"
      />
    </v-col>

    <v-col cols="12" sm="6" class="text-center">
      <slot
        name="right"
        :attributes="{
          exact: true,
          class: 'my-1',
          rounded: true,
          height: '40px',
          width: '100%',
          maxWidth: '332px'
        }"
      />
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "AppBtnsRow"
};
</script>
